'use client';

import Link from 'next/link';
import React, { FC, Fragment } from 'react';

import styles from './part-breadcrumbs.module.scss';

interface IPartBreadcrumbs {
  list?: { text: string; href: string }[];
  text?: string;
  href?: string;
}

const PartBreadcrumbs:FC<IPartBreadcrumbs> = ({ list = [], text, href }) => {
  const listToRender = [...list];
  if (text && href) listToRender.push({ text, href });
  return (
    <div className={styles.container}>
      <div className={styles.breadCrumbsContainer}>
        <Link href="/">Vissa</Link>
        {/* eslint-disable-next-line no-shadow */}
        {listToRender.map(({ text, href }) => (
          <Fragment key={`${text}${href}`}>
            <span>→</span>
            <Link href={href}>{text}</Link>
          </Fragment>
        ))}
      </div>
    </div>
  );
};

export default PartBreadcrumbs;
